// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"1986df4e5453ba7d","src_app_pages_home-page_home-page_module_ts":"3e9ab9279ef3cc15","src_app_pages_static-pages_static-pages_module_ts":"2480652c18227bd6","src_app_pages_wizard_wizard_module_ts":"122b47113441165d"}[chunkId] + ".js";
};